import { Collapse, Form } from 'antd';
import React, { useState } from 'react';
import styled from 'styled-components';
import SearchCriteria from './searchCriteria';
import SearchResult from './searchResult';

const CollapsePanelTitle = styled.div`
  font-weight: bold;
`

const SearchDailyROE: React.FC = () => {
  const [form] = Form.useForm();
  const [searchCriteria, setSearchCriteria] = useState();

  const onSearchClick = () => {
    setSearchCriteria(form.getFieldsValue());
  }

  return (
    <div style={{ height: '100%' }}>
      <div style={{ background: 'white' }}>
        <Collapse
          defaultActiveKey={'search-criteria'}
          expandIconPosition='end'
          ghost
          style={{ background: 'white' }}
        >
          <Collapse.Panel header={<CollapsePanelTitle>Search Criteria</CollapsePanelTitle>} key="search-criteria">
            <SearchCriteria form={form} onSearchClick={onSearchClick} />
          </Collapse.Panel>
        </Collapse>
      </div>
      <SearchResult searchCriteria = {searchCriteria} />
    </div>
  )
}

export default SearchDailyROE
